import { render, staticRenderFns } from "./categorySelect.vue?vue&type=template&id=29170d56&scoped=true&"
import script from "./categorySelect.vue?vue&type=script&lang=js&"
export * from "./categorySelect.vue?vue&type=script&lang=js&"
import style0 from "./categorySelect.vue?vue&type=style&index=0&id=29170d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29170d56",
  null
  
)

export default component.exports